import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=0e19b947&scoped=true"
import script from "./Pagination.vue?vue&type=script&setup=true&lang=js"
export * from "./Pagination.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Pagination.vue?vue&type=style&index=0&id=0e19b947&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e19b947",
  null
  
)

export default component.exports